import { Box, Typography } from '@material-ui/core';
import { CONTESTANT_COLORS } from './streamPalette';

// The two contestants either side of a "vs", in the colours the board gives them
function Versus(props) {
    const variant = props.variant ?? 'h2';
    return (
        <Box display='flex' alignItems='center' justifyContent='center' flexWrap='wrap' style={{ gap: 24 }}>
            <Typography variant={variant} style={{ color: CONTESTANT_COLORS[0] }}>
                {props.contestant1 ?? 'TBD'}
            </Typography>
            <Typography variant={variant} color='textSecondary'> vs </Typography>
            <Typography variant={variant} style={{ color: CONTESTANT_COLORS[1] }}>
                {props.contestant2 ?? 'TBD'}
            </Typography>
        </Box>
    );
}

export default Versus;
